module.exports = __webpack_public_path__ + "static/img/book.af52f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/book.png
// module id = dEzR
// module chunks = 1